import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b2bxmek3gf: FaireBrandEntity = {
  token: "b_b2bxmek3gf",
  type: "brand",
  name: "Kingdom Come Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/fc4d1f86670ffd3b9f965827992468951a1fd4960c020a4d8d9c59a673613bbc.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/abdaf3cec3b4734e2fd1d861ee40a9128adc969b5968178dd8b808669e1f5b40.png",
  logoUrl:
    "https://cdn.faire.com/fastly/fc4d1f86670ffd3b9f965827992468951a1fd4960c020a4d8d9c59a673613bbc.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/abdaf3cec3b4734e2fd1d861ee40a9128adc969b5968178dd8b808669e1f5b40.png",
  location: "Naugatuck , CT, USA",
  minimumOrderDollars: 200,
  rating: 4.8,
  reviewCount: 5,
  isInsider: true,
  description:
    "I started Kingdom Come Co. grounded in a deep personal conviction to incorporate God into everyday activities for my own children. This desire is driven by my hope to raise my children to be in this world but not of it, meaning that they can navigate the secular world while remaining grounded in their faith.\n\nRecognizing the power of play and everyday items to shape a child's experience, I founded Kingdom Come Co. to create products that encourage and help other families incorporate faith into their everyday activities, as well. My products aim to serve as a source of inspiration and support for families who want to instill their values and faith in their children, while also enjoying the everyday moments of life.\n\nThrough my products, I hope to make a positive impact on the lives of children and families by providing them with engaging and accessible ways to connect with their faith. By starting Kingdom Come Co., I hoped to create a space where faith and fun can coexist, helping families like yours raise their children with a sense of purpose, joy, and love.\n\nPax Christi,\nEmily",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:12.077Z",
    importedBy: "entity-db-cli",
  },
};
